import axios, { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from 'redux';
import { GET_STORES } from '../../helpers/constants';
import { request } from '../../helpers/request';

export const getStores = (dispatch: Dispatch) => {
    return request
        .getAllStores()
        .then((response: AxiosResponse) => {
            dispatch({
                type: GET_STORES,
                payload: response.data?.stores
            });
        })

        .catch((err: AxiosError | Error) => {
            if (axios.isAxiosError(err)) {
                console.log(err.response?.data);
            } else {
                console.log(err.message);
            }
        });
};
